var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":'builder' + _vm.id}}),_c('edit_tabulator',{ref:"tabulator",attrs:{"extern_file":false},on:{"data":_vm.update_data,"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }